import React, { useState } from "react";
import Icon from "../../../components/AppIcon";

const CodeEditor = ({
  children,
  title = "developer.json",
  showLineNumbers = true,
}) => {
  const [isDebugMode, setIsDebugMode] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  const lines = children ? children?.toString()?.split("\n")?.length : 1;

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden terminal-glow">
      {/* Editor Header */}
      <div className="bg-muted/30 px-4 py-2 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="flex space-x-1">
              <button
                onClick={() => setIsMinimized(!isMinimized)}
                className="w-3 h-3 bg-destructive rounded-full hover:bg-destructive/80 transition-colors"
              />
              <div className="w-3 h-3 bg-warning rounded-full" />
              <div className="w-3 h-3 bg-success rounded-full" />
            </div>
            <div className="flex items-center space-x-2">
              <Icon
                name="FileText"
                size={14}
                className="text-muted-foreground"
              />
              <span className="text-sm font-source text-foreground">
                {title}
              </span>
              <div className="w-2 h-2 bg-primary rounded-full animate-pulse" />
            </div>
          </div>

          <div className="flex items-center space-x-2">
            <button
              onClick={() => setIsDebugMode(!isDebugMode)}
              className={`px-2 py-1 text-xs font-source rounded transition-colors ${
                isDebugMode
                  ? "bg-primary text-primary-foreground"
                  : "bg-muted text-muted-foreground hover:text-foreground"
              }`}
            >
              {isDebugMode ? "Debug ON" : "Debug OFF"}
            </button>
            <div className="hidden sm:flex items-center space-x-1 text-xs text-muted-foreground">
              <Icon name="Zap" size={12} />
              <span>JSON</span>
            </div>
          </div>
        </div>
      </div>

      {/* Editor Toolbar */}
      <div className="bg-background/50 px-4 py-1 border-b border-border/50 flex items-center justify-between">
        <div className="flex items-center space-x-4 text-xs text-muted-foreground">
          <div className="flex items-center space-x-1">
            <Icon name="GitBranch" size={12} />
            <span>main</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Users" size={12} />
            <span>1 developer</span>
          </div>
          <div className="hidden sm:flex items-center space-x-1">
            <Icon name="Clock" size={12} />
            <span>Last updated: {new Date()?.toLocaleDateString()}</span>
          </div>
        </div>

        <div className="flex items-center space-x-2 text-xs">
          <div className="flex items-center space-x-1 text-success">
            <div className="w-2 h-2 bg-success rounded-full animate-pulse" />
            <span>Syntax OK</span>
          </div>
          <span className="text-muted-foreground">Lines: {lines}</span>
        </div>
      </div>
      {/* Editor Content */}

      {!isMinimized && (
        <div className="relative w-[320px] sm:w-full overflow-auto">
          {showLineNumbers && (
            <div className="absolute left-0 top-0 bottom-0 w-6 bg-muted/20 border-r border-border flex flex-col text-xs text-muted-foreground font-source">
              {Array.from({ length: lines }, (_, i) => (
                <div key={i + 1} className="px-2 py-0.5 text-right leading-6">
                  {i + 1}
                </div>
              ))}
            </div>
          )}

          <div
            className={`${
              showLineNumbers ? "ml-4" : ""
            } p-4 bg-background/30 min-h-[400px] overflow-x-auto`}
          >
            {isDebugMode && (
              <div className="mb-4 p-3 bg-warning/10 border border-warning/20 rounded text-sm">
                <div className="flex items-center space-x-2 text-warning mb-2">
                  <Icon name="AlertTriangle" size={16} />
                  <span className="font-medium">Debug Mode Active</span>
                </div>
                <p className="text-muted-foreground">
                  Showing real technical achievements and certifications. Toggle
                  off for the "learning frontend" experience.
                </p>
              </div>
            )}
            {children}
          </div>
        </div>
      )}
      {isMinimized && (
        <div className="p-4 text-center text-muted-foreground">
          <Icon name="Minimize2" size={24} className="mx-auto mb-2" />
          <p className="text-sm">
            Editor minimized - Click red button to restore
          </p>
        </div>
      )}
    </div>
  );
};

export default CodeEditor;
